import { MenuItem } from 'primeng/api';

import { UserPermissions } from '@osf/shared/enums/user-permissions.enum';

import { CustomMenuItem } from '../models/custom-menu-item.model';

export const AUTHENTICATED_MENU_ITEMS: string[] = [
  'my-profile',
  'my-resources',
  'my-registrations',
  'my-projects',
  'my-preprints',
  'settings',
];

export const VIEW_ONLY_PROJECT_MENU_ITEMS: string[] = [
  'project-overview',
  'project-files',
  'project-wiki',
  'project-analytics',
  'project-links',
];

export const VIEW_ONLY_REGISTRY_MENU_ITEMS: string[] = [
  'registration-overview',
  'registration-files',
  'registration-wiki',
  'registration-analytics',
  'registration-components',
  'registration-recent-activity',
];

export const PROJECT_MENU_ITEMS: CustomMenuItem[] = [
  {
    id: 'project-overview',
    label: 'navigation.overview',
    routerLink: 'overview',
    visible: true,
    routerLinkActiveOptions: { exact: false },
  },
  {
    id: 'project-metadata',
    label: 'navigation.metadata',
    routerLink: 'metadata',
    visible: true,
    routerLinkActiveOptions: { exact: false },
  },
  {
    id: 'project-files',
    label: 'navigation.files',
    routerLink: 'files',
    visible: true,
    routerLinkActiveOptions: { exact: false },
  },
  {
    id: 'project-wiki',
    label: 'navigation.wiki',
    routerLink: 'wiki',
    visible: true,
    routerLinkActiveOptions: { exact: false },
  },
  {
    id: 'project-registrations',
    label: 'navigation.registrations',
    routerLink: 'registrations',
    visible: true,
    routerLinkActiveOptions: { exact: false },
  },
  {
    id: 'project-contributors',
    label: 'navigation.contributors',
    routerLink: 'contributors',
    visible: true,
    requiredPermission: UserPermissions.Read,
    routerLinkActiveOptions: { exact: false },
  },
  {
    id: 'project-analytics',
    label: 'navigation.analytics',
    routerLink: 'analytics',
    visible: true,
    routerLinkActiveOptions: { exact: false },
  },
  {
    id: 'project-addons',
    label: 'navigation.addons',
    routerLink: 'addons',
    visible: true,
    requiredPermission: UserPermissions.Write,
    routerLinkActiveOptions: { exact: false },
  },
  {
    id: 'project-linked-services',
    label: 'navigation.linkedServices',
    routerLink: 'links',
    visible: true,
    routerLinkActiveOptions: { exact: false },
  },
  {
    id: 'project-settings',
    label: 'navigation.settings',
    routerLink: 'settings',
    visible: true,
    requiredPermission: UserPermissions.Read,
    routerLinkActiveOptions: { exact: false },
  },
];

export const PREPRINT_MENU_ITEMS: MenuItem[] = [
  {
    id: 'preprint-overview',
    label: 'navigation.overview',
    routerLink: 'overview',
    visible: true,
    routerLinkActiveOptions: { exact: true },
  },
];

export const REGISTRATION_MENU_ITEMS: CustomMenuItem[] = [
  {
    id: 'registration-overview',
    label: 'navigation.overview',
    routerLink: 'overview',
    visible: true,
    routerLinkActiveOptions: { exact: false },
  },
  {
    id: 'registration-metadata',
    label: 'navigation.metadata',
    routerLink: 'metadata',
    visible: true,
    routerLinkActiveOptions: { exact: false },
  },
  {
    id: 'registration-files',
    label: 'navigation.files',
    routerLink: 'files',
    visible: true,
    routerLinkActiveOptions: { exact: false },
  },
  {
    id: 'registration-resources',
    label: 'navigation.resources',
    routerLink: 'resources',
    visible: true,
    routerLinkActiveOptions: { exact: true },
  },
  {
    id: 'registration-wiki',
    label: 'navigation.wiki',
    routerLink: 'wiki',
    visible: true,
    routerLinkActiveOptions: { exact: false },
  },
  {
    id: 'registration-components',
    label: 'navigation.components',
    routerLink: 'components',
    visible: true,
    routerLinkActiveOptions: { exact: true },
  },
  {
    id: 'registration-contributors',
    label: 'navigation.contributors',
    routerLink: 'contributors',
    visible: true,
    requiredPermission: UserPermissions.Read,
    routerLinkActiveOptions: { exact: true },
  },
  {
    id: 'registration-links',
    label: 'navigation.links',
    routerLink: 'links',
    visible: true,
    routerLinkActiveOptions: { exact: true },
  },
  {
    id: 'registration-analytics',
    label: 'navigation.analytics',
    routerLink: 'analytics',
    visible: true,
    routerLinkActiveOptions: { exact: false },
  },
  {
    id: 'registration-recent-activity',
    label: 'navigation.recentActivity',
    routerLink: 'recent-activity',
    visible: true,
    routerLinkActiveOptions: { exact: true },
  },
];

export const MENU_ITEMS: CustomMenuItem[] = [
  {
    id: 'home',
    routerLink: '/',
    label: 'navigation.home',
    icon: 'fas fa-home',
    routerLinkActiveOptions: { exact: true },
    visible: true,
  },
  {
    id: 'search',
    routerLink: '/search',
    label: 'navigation.searchOsf',
    icon: 'fas fa-magnifying-glass',
    routerLinkActiveOptions: { exact: false },
    visible: true,
  },
  {
    id: 'support',
    routerLink: null,
    label: 'navigation.support',
    icon: 'fas fa-headset',
    styleClass: 'mb-5',
    url: 'https://help.osf.io/',
    routerLinkActiveOptions: { exact: false },
    visible: true,
  },
  {
    id: 'my-resources',
    label: 'navigation.myOsf',
    icon: 'custom-icon-projects',
    routerLinkActiveOptions: { exact: true },
    visible: false,
    items: [
      {
        id: 'my-projects',
        routerLink: '/my-projects',
        label: 'navigation.myProjects',
        routerLinkActiveOptions: { exact: false },
        visible: false,
      },
      {
        id: 'my-registrations',
        routerLink: '/my-registrations',
        label: 'navigation.registriesSubRoutes.myRegistrations',
        visible: false,
        routerLinkActiveOptions: { exact: false },
      },
      {
        id: 'my-preprints',
        routerLink: '/my-preprints',
        label: 'navigation.preprintsSubRoutes.myPreprints',
        visible: false,
        routerLinkActiveOptions: { exact: false },
      },
    ],
  },
  {
    id: 'projects',
    label: 'navigation.projects',
    icon: 'custom-icon-projects',
    routerLinkActiveOptions: { exact: true },
    visible: false,
    items: [
      {
        id: 'project-details',
        label: 'navigation.projectDetails',
        icon: 'custom-icon-projects',
        routerLink: null,
        visible: false,
        routerLinkActiveOptions: { exact: true },
        styleClass: 'border-none',
      },
    ],
  },
  {
    id: 'registries',
    label: 'navigation.registries',
    icon: 'custom-icon-registries',
    visible: true,
    routerLinkActiveOptions: { exact: true },
    items: [
      {
        id: 'registries-overview',
        routerLink: '/registries/discover',
        label: 'navigation.discover',
        visible: true,
        routerLinkActiveOptions: { exact: false },
      },
      {
        id: 'registries-moderation',
        routerLink: '/registries',
        label: 'navigation.moderation',
        visible: false,
        routerLinkActiveOptions: { exact: false },
      },
      {
        id: 'registry-details',
        label: 'navigation.registriesSubRoutes.registryDetails',
        icon: 'custom-icon-registries',
        routerLinkActiveOptions: { exact: true },
        visible: false,
        styleClass: 'border-none',
      },
    ],
  },
  {
    id: 'preprints',
    label: 'navigation.preprints',
    icon: 'custom-icon-preprints',
    visible: true,
    routerLinkActiveOptions: { exact: true },
    items: [
      {
        id: 'preprints-overview',
        routerLink: '/preprints/discover',
        label: 'navigation.discover',
        visible: true,
        routerLinkActiveOptions: { exact: false },
      },
      {
        id: 'preprints-moderation',
        routerLink: '/preprints/my-reviewing',
        label: 'navigation.moderation',
        visible: false,
        routerLinkActiveOptions: { exact: true },
      },
      {
        id: 'preprints-details',
        label: 'navigation.preprintsSubRoutes.preprintDetails',
        icon: 'custom-icon-preprints',
        routerLinkActiveOptions: { exact: true },
        visible: false,
        styleClass: 'border-none',
      },
    ],
  },
  {
    id: 'collections',
    label: 'navigation.collections',
    icon: 'custom-icon-collections',
    visible: true,
    routerLinkActiveOptions: { exact: false },
    items: [
      {
        id: 'collections-moderation',
        routerLink: 'moderation',
        label: 'navigation.moderation',
        visible: false,
        routerLinkActiveOptions: { exact: false },
      },
    ],
  },
  {
    id: 'meetings',
    routerLink: '/meetings',
    label: 'navigation.meetings',
    icon: 'custom-icon-meetings',
    visible: true,
    routerLinkActiveOptions: { exact: false },
  },
  {
    id: 'institutions',
    routerLink: '/institutions',
    label: 'navigation.institutions',
    icon: 'custom-icon-institutions',
    visible: true,
    routerLinkActiveOptions: { exact: false },
    styleClass: 'mb-5',
  },
  {
    id: 'my-profile',
    routerLink: '/profile',
    label: 'navigation.profile',
    icon: 'fas fa-user',
    visible: false,
    routerLinkActiveOptions: { exact: false },
  },
  {
    id: 'settings',
    label: 'navigation.settings',
    icon: 'fas fa-gear',
    routerLinkActiveOptions: { exact: true },
    visible: false,
    items: [
      {
        id: 'settings-profile',
        routerLink: '/settings/profile',
        label: 'navigation.profileSettings',
        visible: true,
        routerLinkActiveOptions: { exact: true },
      },
      {
        id: 'settings-account',
        routerLink: '/settings/account',
        label: 'navigation.accountSettings',
        visible: true,
        routerLinkActiveOptions: { exact: true },
      },
      {
        id: 'settings-addons',
        routerLink: '/settings/addons',
        label: 'navigation.configureAddonAccounts',
        visible: true,
        routerLinkActiveOptions: { exact: false },
      },
      {
        id: 'settings-notifications',
        routerLink: '/settings/notifications',
        label: 'navigation.notifications',
        visible: true,
        routerLinkActiveOptions: { exact: true },
      },
      {
        id: 'settings-developer-apps',
        routerLink: '/settings/developer-apps',
        label: 'navigation.developerApps',
        visible: true,
        routerLinkActiveOptions: { exact: false },
      },
      {
        id: 'settings-tokens',
        routerLink: '/settings/tokens',
        label: 'navigation.personalAccessTokens',
        visible: true,
        routerLinkActiveOptions: { exact: false },
      },
    ],
  },
  {
    id: 'donate',
    routerLink: null,
    routerLinkActiveOptions: { exact: false },
    label: 'navigation.donate',
    icon: 'fas fa-hand-holding-dollar',
    url: 'https://www.cos.io/support-cos',
    visible: true,
  },
  {
    id: 'sign-in',
    label: 'navigation.signIn',
    icon: 'fas fa-arrow-right-to-bracket',
    routerLink: null,
    routerLinkActiveOptions: { exact: false },
    visible: false,
    styleClass: 'my-5',
  },
  {
    id: 'log-out',
    label: 'navigation.logOut',
    icon: 'fas fa-arrow-right-from-bracket',
    routerLink: null,
    routerLinkActiveOptions: { exact: false },
    visible: false,
    styleClass: 'my-5',
  },
];
